<template>
  <div class="logindiv">
    <div class="logo">
      <img alt="logo" src="@/assets/Logo MOPE slo.svg" height="80">
    </div>
    <form novalidate @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="passdiv">
        <div class="userpasspanel p-float-label p-input-icon-right">
          <InputText id="password" type="password" v-model="v$.password.$model" aria-describedby="password-error"/>
          <label for="password">{{ translated('password') }}*</label>
        </div>
        <div class="userpasspanel p-float-label p-input-icon-right" style="margin-top:20px;">
          <InputText id="repeatpass" type="password" v-model="v$.repeatpass.$model" aria-describedby="repeatpass-error"/>
          <label for="repeatpass">{{ translated('repeatpass') }}*</label>
        </div>
      </div>
      <div class="errordiv">
        <small v-if="(error || errorApp) && isChanged==false">{{ error }} {{ errorApp }}</small>
      </div>
      <div class="submitbutton">
        <Button :label="translated('changepassword')" @click="handleSubmit(!v$.$invalid)" />
      </div>
    </form>
  </div>
</template>

<script>
import { computed } from "vue";
import store from "@/store";
import { required, minLength, sameAs } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import router from "@/router";

const strongPassword = (value) => {
  if (!value) return false;
  // At least 8 chars, one uppercase, one lowercase, one number, one special char
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(value);
};

export default {
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      password: '',
      repeatpass: '',
      submitted: false,
      isChanged: false,
      errorApp: '',
      error: computed(() => store.state.error),
      translated: computed(() => store.getters.getTranslate),
      u: null,
      c: null
    }
  },
  validations() {
    return {
      password: {
        required,
        strongPassword
      },
      repeatpass: {
        required,
        sameAsPassword: sameAs(this.password)
      }
    }
  },
  created() {
    store.dispatch("removeErrorMessage");
    // Read params u and c from URL
    this.u = this.$route.query.u;
    this.c = this.$route.query.c;
  },
  methods: {
    async handleSubmit(isFormValid) {
        debugger;
      this.isChanged = false;
      this.submitted = true;
      if (!isFormValid) {
        this.showMessageForSomeTime(this.translated('notvalidpassword'));
        return;
      }
      if (this.password !== this.repeatpass) {
        this.showMessageForSomeTime(this.translated('passwordsnotequal'));
        return;
      }
      let model = {
        Password: this.password,
        UG: this.u,
        CG: this.c
      };

      await store.dispatch("changePassword", model);
    },
    showMessageForSomeTime(message) {
        this.errorApp = message;
        setTimeout(() => {
            this.errorApp = null;
        }, 7000); // Message will disappear after 7 seconds
    }    
  }
}
</script>

<style scoped>
.donthaveaccount {
  text-align: center;
  cursor: pointer;
}

form {
  background: white;
  padding: 20px;
  border-radius: 0 0 10px 10px;
}

form button {
  display: block;
  margin: 60px auto 0;
}

.logindiv .logo {
  padding: 10px;
  border-top: 2px solid white;
  border-left: 2px solid white;
  border-right: 2px solid white;
  display: flex;
  justify-content: center;
}

.userpasspanel {
  width: 100%;
}

.usernamediv {
  margin-top: 30px;
}

i.pi.pi-envelope.ikonaemail {
  top: 15px;
  right: 7px;
}
</style>